import { makeAutoObservable } from 'mobx';
import { AuthStore, authStore } from './AuthStore';
import { ToastStore, toastStore } from './ToastStore';
import { ServicesStore, servicesStore } from './ServicesStore';
import { BookingsStore, bookingsStore } from './BookingsStore';
import { OperatingHoursStore, operatingHoursStore } from './OperatingHoursStore';
import { NotificationStore, notificationStore } from './NotificationStore';
import { AnalyticsStore, analyticsStore } from './AnalyticsStore';
import { PostsStore, postsStore } from './PostsStore';
import { employeePositionsStore, type EmployeePositionsStore } from './EmployeePositionsStore';
import { employeesStore, type EmployeesStore } from './EmployeesStore';
import { employeePaymentSchemeStore, type EmployeePaymentSchemeStore } from './EmployeePaymentSchemeStore';
import { paymentSchemeTemplatesStore, type PaymentSchemeTemplatesStore } from './PaymentSchemeTemplatesStore';
import { shiftsStore, type ShiftsStore } from './ShiftsStore';
import { shiftDraftStore, type ShiftDraftStore } from './ShiftDraftStore';
import { shiftTemplatesStore, type ShiftTemplatesStore } from './ShiftTemplatesStore';
import { shiftViewStore, type ShiftViewStore } from './ShiftViewStore';

/**
 * Root store that combines all application stores
 */
export class RootStore {
  authStore: AuthStore;
  toastStore: ToastStore;
  servicesStore: ServicesStore;
  bookingsStore: BookingsStore;
  operatingHoursStore: OperatingHoursStore;
  notificationStore: NotificationStore;
  analyticsStore: AnalyticsStore;
  postsStore: PostsStore;
  employeePositionsStore: EmployeePositionsStore;
  employeesStore: EmployeesStore;
  employeePaymentSchemeStore: EmployeePaymentSchemeStore;
  paymentSchemeTemplatesStore: PaymentSchemeTemplatesStore;
  shiftsStore: ShiftsStore;
  shiftDraftStore: ShiftDraftStore;
  shiftTemplatesStore: ShiftTemplatesStore;
  shiftViewStore: ShiftViewStore;

  constructor() {
    // Используем singleton instances
    this.authStore = authStore;
    this.toastStore = toastStore;
    this.servicesStore = servicesStore;
    this.bookingsStore = bookingsStore;
    this.operatingHoursStore = operatingHoursStore;
    this.notificationStore = notificationStore;
    this.analyticsStore = analyticsStore;
    this.postsStore = postsStore;
    this.employeePositionsStore = employeePositionsStore;
    this.employeesStore = employeesStore;
    this.employeePaymentSchemeStore = employeePaymentSchemeStore;
    this.paymentSchemeTemplatesStore = paymentSchemeTemplatesStore;
    this.shiftsStore = shiftsStore;
    this.shiftDraftStore = shiftDraftStore;
    this.shiftTemplatesStore = shiftTemplatesStore;
    this.shiftViewStore = shiftViewStore;
    
    // Устанавливаем ссылку на rootStore в operatingHoursStore
    this.operatingHoursStore.setRootStore(this);
    
    makeAutoObservable(this);
  }
}

// Create a single instance of the root store
export const rootStore = new RootStore();